import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { Table } from '@/components/Table/Table';
import { entradaProdutoKeys, fetchBarcodeModelos } from '@/services/entradaProdutoService';
import './modelos-barcode.css';

export const Route = createFileRoute('/_authenticated/configuracao/modelos-barcode/')({
  component: ModelosBarcodePage,
});

function extractApiError(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { error?: string } | undefined;
    if (typeof data?.error === 'string') return data.error;
    return error.message;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}

function ModelosBarcodePage() {
  const { data = [], isLoading, isError, error } = useQuery({
    queryKey: entradaProdutoKeys.barcodeModelos,
    queryFn: fetchBarcodeModelos,
  });

  return (
    <div className="modelos-barcode-page">
      <div className="modelos-barcode-page__header">
        <h1>Modelos de código de barras</h1>
        <p className="modelos-barcode-page__subtitle">
          Regras de interpretação usadas na Entrada de Produtos (somente leitura).
        </p>
      </div>

      {isError && (
        <p className="modelos-barcode-page__error" role="alert">
          {extractApiError(error, 'Falha ao carregar modelos.')}
        </p>
      )}

      <div className="modelos-barcode-page__table-container">
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.Head scope="col">Nome</Table.Head>
              <Table.Head scope="col">Valor</Table.Head>
              <Table.Head scope="col">Descrição</Table.Head>
              <Table.Head scope="col">Comprimento</Table.Head>
              <Table.Head scope="col">Fixo</Table.Head>
            </Table.Row>
          </Table.Header>
          <Table.Content>
            {isLoading && (
              <Table.Row>
                <Table.Cell colSpan={5}>Carregando…</Table.Cell>
              </Table.Row>
            )}
            {!isLoading && data.length === 0 && (
              <Table.Row>
                <Table.Cell colSpan={5}>Nenhum modelo cadastrado para o tenant.</Table.Cell>
              </Table.Row>
            )}
            {data.map((row) => (
              <Table.Row key={row.id}>
                <Table.Cell>{row.name}</Table.Cell>
                <Table.Cell>{row.value}</Table.Cell>
                <Table.Cell>{row.description || '—'}</Table.Cell>
                <Table.Cell>{row.length ?? '—'}</Table.Cell>
                <Table.Cell>{row.is_fixed ? 'Sim' : 'Não'}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Content>
        </Table>
      </div>
    </div>
  );
}
